module.exports = __webpack_public_path__ + "img/passwordIcon.9a1b622f.svg";